/**
 * GetParamデータクラス
 * */
export class getParam {

	// デザイン番号
	public designNo: string;

	// リテーラID
	public retailerId: string;

	// 1枚無料フラグ
	public trial: string;

	// 戻るURL
	public returnUrl: string;

	// 保存ID
	public saveId: string | null;

	// 保存ID2
	public saveId2: string;

	// 追加注文
	public addOrder: string;

	// カートラインキー
	public cart_line_key: string;

	// 仕上がり選択
	public printType: string | null;
}